import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import { floatControlLabel } from '@project/shared/utils/form-control/js/form-control';
import * as copy from 'copy-to-clipboard';

const classes = {
	stateModalShow: 'state-favourite-popup--visible',
	modalSubmit: 'js-m-modal-actions-submit',
	modalClose: 'js-m-modal-actions-close',
	modalDialog: "js-m-modal-actions__dialog",
	clipboardAnchor: "js-m-modal-actions__clipboard-anchor",
	removeEmail: "js-remove-email-input",
	addEmail: "js-add-email-input",
	addEmailDisabled : 'state-m-modal-actions__add-email--disabled',
	emailTemplate: "js-m-modal-actions__email-template",
	textarea: "js-m-modal-actions__textarea",
	textareaValLength: "js-m-modal-actions__textarea-count-length",
	textareaValLengthMax: "js-m-modal-actions__textarea-count-max",
	stateCountMax: "state-textarea-count-max",
	openTooltip: "js-m-modal-actions--open-tooltip",
	termsCheckbox: "js-m-modal-actions__terms",
	stateInputError: "input-validation-error",
	newlistWrapper: "js-m-modal-actions__new-list",
	emailWrapper: "js-m-modal-actions__email-group",
};

@createModule('ModalActions')
/**
 * modal-actions module implementation.
 */
export class ModalActions extends TerrificSpec {
	$ctx: JQuery;
	/**
	 * start method, called on terrific bootstap
	 *
	 * @param {Object} resolve  function to call at the end of component start
	 * @returns {void}
	 */
	start(resolve: () => void) {
		this.$ctx = $(this._ctx);

		this._closeModal();
		this._submitModal();
		this._openTooltip();

		this.$ctx.on('click', this._hidePopup.bind(this));

		const $modalDialog = this.$ctx.find(`.${classes.modalDialog}`);
		$modalDialog.on('click', (ev: Event) => {
			ev.stopPropagation();
		});
		
		const $clipboardAnchor = this.$ctx.find(`.${classes.clipboardAnchor}`);
		$clipboardAnchor.on('click', () => this.copyURLToClipboard());

		this.addEmaillAdress();

		this.changeTextareaCount();
		
		resolve();
	}

	_submitModal() {
		const $modalSubmit = this.$ctx.find(`.${classes.modalSubmit}`);
		$modalSubmit.on('click', () => {
			this.newListValidation();
			this.emailListValidation();
		});
	}

	emailListValidation() {
		const $emailWrapper = this.$ctx.find(`.${classes.emailWrapper}`);
		const $input = $emailWrapper.find("input[type='email']")
		if($input.val() == "") {
			$input.addClass(classes.stateInputError)
			$input.on("input propertychange",function(ev: any){
				const $target: any = $(ev.currentTarget);
				$target.removeClass(classes.stateInputError)
			})
		}
	}

	newListValidation() {
		const $newlistWrapper = this.$ctx.find(`.${classes.newlistWrapper}`);
		const $checkedbox = $newlistWrapper.find("input[type='checkbox']")
		const $input = $newlistWrapper.find("input[type='text']")
		if($checkedbox.is(":checked") && $input.val() == "") {
			$input.addClass(classes.stateInputError)
			$input.on("input propertychange",function(ev: any){
				const $target: any = $(ev.currentTarget);
				$target.removeClass(classes.stateInputError)
			})
		}
	}

	changeTextareaCount() {
		const $textarea = this.$ctx.find(`.${classes.textarea}`);
		$textarea.on("input propertychange",function(ev: any){
			const $target: any = $(ev.currentTarget);
			const $textareaValLength = $target.parent().find(`.${classes.textareaValLength}`);
			const $textareaValLengthMax = $target.parent().find(`.${classes.textareaValLengthMax}`);
			const textVal = $target.val();
			const currentCount = parseInt($textareaValLengthMax.text()) - textVal.length;
			if ( currentCount > 0) {
				$textareaValLength.text(currentCount);
				$textareaValLength.parent().removeClass(classes.stateCountMax)
			} else {
				$textareaValLength.text('0');
				$textareaValLength.parent().addClass(classes.stateCountMax)
			};
		})
	}

	/**
	 * Copies the URL (location.href) into the browser clipboard
	 * @constructor {function}
	 * @returns {void}
	 */
	copyURLToClipboard(): void {
		const opts: any = this.getClipboardOpts();
		const data = this.getLocationHref();

		this.showFeedbackMsg();
		copy(data, opts);
		this.hideFeedbackMsgTimer();
	}

	/**
	 * getClipboardOpts
	 * @constructor {function} getClipboardOpts
	 * @returns {Object} any
	 */
	getClipboardOpts(): any {
		return {
			debug: false,
			message: 'Press #{⌘+C} on macOS or #{Ctrl+C} on Windows to copy',
		};
	}

	/**
	 * getLocationHref
	 * @constructor {function} getLocationHref
	 * @returns {string} string
	 */
	getLocationHref(): string {
		return document.location.href;
	}

	/**
	 * showDebugInfo - Description
	 * @constructor {function} showDebugInfo
	 * @param {Object} opts holds thze options for the clipboard object
	 * @param {string} data holds the data to be copied into the clipboard
	 */
	showDebugInfo(opts: any, data: string) {
		if (opts.debug) {
			// eslint-disable-next-line no-console
			console.log('Copied to clipboard: ', data);
		}
	}

	/**
	 * showFeedbackMsg
	 * @constructor {function} showFeedbackMsg
	 */
	showFeedbackMsg() {
		const $clipboardAnchor = this.$ctx.find(`.${classes.clipboardAnchor}`);
		$clipboardAnchor.prev().removeClass('show');
		$clipboardAnchor.prev().addClass('show');
	}

	/**
	 * hideFeedbackMsg
	 * @constructor {function} hideFeedbackMsg
	 */
	hideFeedbackMsg() {
		const $clipboardAnchor = this.$ctx.find(`.${classes.clipboardAnchor}`);
		$clipboardAnchor.prev().removeClass('show');
	}

	/**
	 * showFeedbackMsg
	 * @constructor {function} showFeedbackMsg
	 */
	hideFeedbackMsgTimer() {
		window.setTimeout(() => {
			this.hideFeedbackMsg();
		}, 3500);
	}

	_closeModal() {
		const $modalClose = this.$ctx.find(`.${classes.modalClose}`);
		$modalClose.on('click', this._hidePopup.bind(this));
	}

	_openTooltip() {
		const $openTooltip = this.$ctx.find(`.${classes.openTooltip}`);
		const $checkedbox = this.$ctx.find(`.${classes.termsCheckbox}`).find("input[type='checkbox']");
		$openTooltip.on('click', () => {
			const curScrollTop = $(window).scrollTop();
			if($checkedbox.is(":checked")) {
				$(window).scrollTop(curScrollTop - 20);
				$('.m-navigation-meta__tooltip-favourite').fadeIn();
			}
		});
	}

	_hidePopup(ev: Event) {
		if($(ev.currentTarget).hasClass('js-m-modal-actions-confirmation')) {
			this.$ctx.removeClass(classes.stateModalShow);
		} else {
			this.$ctx.removeClass(classes.stateModalShow);
			$('html').removeClass('no-scrolling--without-scrollbar');
		}
	}

	// Add new email
	addEmaillAdress() {
		const $addEmail = this.$ctx.find(`.${classes.addEmail}`);
		const $emailTemplate = this.$ctx.find(`.${classes.emailTemplate}`);
		const $emailTemplateHtml = $emailTemplate.html();
		$addEmail.on('click', () => {
			var emailLength = this.$ctx.find('.m-modal-actions__email-group').length;
			if ( emailLength > 9 ) {
				$addEmail.addClass(classes.addEmailDisabled);
			}
			$emailTemplate.before($emailTemplateHtml);
			$('.m-modal-actions__sub-email-group').on("focus",'.a-input',(ev: any) => {
				const me = ev.currentTarget;
				floatControlLabel(me, true)
			})
		});
		$('.m-modal-actions__form').on("click",'.js-remove-email-input',(ev: Event) => {
			$(ev.currentTarget).parent().remove();
			$addEmail.removeClass(classes.addEmailDisabled);
		})
	}

	/**
	 * stop method, called on terrific stop
	 *
	 * @returns {void}
	 */
	stop() {}
}
